import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { PusherProvider } from './components/common/PusherContext';
import { datadogRum } from '@datadog/browser-rum';
import { reactPlugin } from '@datadog/browser-rum-react';
import { DATADOGRUM_API_KEY, DATADOGRUM_API_SITE, DATADOGRUM_API_TOKEN } from './helpers/constant';

datadogRum.init({
  applicationId: '6699ff1b-18f2-48e3-a376-0c9c32debd10',
  clientToken: 'pub49aaf3e0ba99175709ca327615f4e339',
  // site refers to the Datadog site parameter of your organization
  // see https://docs.datadoghq.com/getting_started/site/
  site: 'us5.datadoghq.com',
  service: 'frontend',
  env: 'prod',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 98,
  defaultPrivacyLevel: 'allow',
});



const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PusherProvider>
      <App />
    </PusherProvider>
  </Provider>,
  // </React.StrictMode>,
);

reportWebVitals();
